import CookieHelper from "./CookieHelper.js";
import NotificationMessage from "../../utils/stringLiterals/NotificationMessage.js";

//TESTED
const insertSessionInCookieStorage = function(sessionName, sessionValue, optionsObject){
    try{
        //console.log('optionsObject', optionsObject);
        let properties = {
            path: optionsObject.path,
            maxAge : optionsObject.maxAge,
            sameSite: 'Lax'
        }

        CookieHelper.setCookie(sessionName, sessionValue, properties.path, properties.sameSite, properties.maxAge);
        
        return 'ok';
    }
    catch(error){

        const errorMessage = new Error(NotificationMessage.sessionSavingError , error);
        //console.log('errorMessage', errorMessage);

        return NotificationMessage.sessionSavingError;
    }
}


const getSessionFromCookieStorage = function(cookieName){
    let selectedCookie = CookieHelper.getCookieValueByName(cookieName);

    return selectedCookie;
}

const deleteSessionFromCookieStorageByNameAndPath = function(cookieName, cookiePath){
    try{
        CookieHelper.deleteCookieByNameSecurely(cookieName, cookiePath);
        return 'OK';
    }
    catch(error){
        let errorMessage= new Error('Failed to Delete the cookie from the storage: ', error);
        MonitorService.capture('errorMessage', errorMessage);
        return errorMessage;
    }
}

const SessionDataStorer = Object.freeze({
    insertSessionInCookieStorage : insertSessionInCookieStorage,
    getSessionFromCookieStorage : getSessionFromCookieStorage,
    deleteSessionFromCookieStorageByNameAndPath : deleteSessionFromCookieStorageByNameAndPath,
});

export default SessionDataStorer;